import { useEffect } from "react";
import { useKeyPress } from './useKeyPress';

export const useKeyPressedOnce = (key: string, callback: () => void) => {
  const pressed = useKeyPress(key);

  useEffect(() => {
    if (pressed) {
      callback();
    }
  }, [pressed, callback]);
}
